<div class="flex items-center gap-1 text-grey text-sm">
	<ng-container *ngIf="lawyer$ | async as lawyer">
		<span
			[matTooltip]="lawyer.name"
			class="text-bold"
			[testHook]="testHooks.LawyerInitialsSpan"
			>{{ lawyer.initials | uppercase }}</span
		>
	</ng-container>
	<app-icon
		*ngIf="showPipe$ | async"
		[icon]="ICON.PIPE"
		class="text-grey-light"
		[testHook]="testHooks.PipeIcon"
	></app-icon>
	<ng-container *ngIf="clerk$ | async as clerk">
		<span [matTooltip]="clerk.name" [testHook]="testHooks.ClerkInitialsSpan">{{
			clerk.initials | lowercase
		}}</span>
	</ng-container>
</div>
